import { format } from 'date-fns';
import { ArrowUpDown } from 'lucide-react';

import type { StatusPageSubscriber } from '@/types/service/statusPageSubscribers';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

import { ColumnDef } from '@tanstack/react-table';

export const subscriberColumns: ColumnDef<StatusPageSubscriber>[] = [
  {
    accessorKey: 'email',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className='hover:bg-transparent p-0'
        >
          Email
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return <span className='font-medium'>{row.getValue('email')}</span>;
    },
  },
  {
    accessorKey: 'client_short_name',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className='hover:bg-transparent p-0'
        >
          Client
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return <span>{row.getValue('client_short_name')}</span>;
    },
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className='hover:bg-transparent p-0'
        >
          Subscribed On
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      const dateValue = row.getValue('created_at') as string;
      return <span>{format(new Date(dateValue), 'MMM dd, yyyy h:mm a')}</span>;
    },
  },
  {
    id: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const unsubscribedAt = row.original.unsubscribed_at;
      const isActive = !unsubscribedAt;

      return (
        <Badge variant={isActive ? 'default' : 'secondary'} className='font-normal'>
          {isActive ? 'Active' : 'Unsubscribed'}
        </Badge>
      );
    },
  },
  {
    accessorKey: 'unsubscribed_at',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
          className='hover:bg-transparent p-0'
        >
          Unsubscribed On
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      const dateValue = row.getValue('unsubscribed_at') as string | null;
      if (!dateValue) {
        return <span className='text-muted-foreground italic'>N/A</span>;
      }
      return <span>{format(new Date(dateValue), 'MMM dd, yyyy h:mm a')}</span>;
    },
  },
];
